import { render, staticRenderFns } from "./MapView.vue?vue&type=template&id=00477ed7&lang=pug"
import script from "./MapView.vue?vue&type=script&lang=js"
export * from "./MapView.vue?vue&type=script&lang=js"
import style0 from "./MapView.vue?vue&type=style&index=0&id=00477ed7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports